module.exports = __webpack_public_path__ + "static/scenttrunk_logo-2e45355983583673b28ddb5f4a4f8cff.svg";